import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import * as list from "src/core/statics/form-data/form-data";
import SelectSearchBarComponent from "src/components/user/select-search-bar-component";
import { appRoutesObj } from "src/app.paths";

function SearchBarComponent() {
  const { i18n, t } = useTranslation();

  const [valueCuntry, setValueCountry] = useState<string>("");
  const [valueSystem, setValueSystem] = useState<string>("");
  const [valueLevel, setValueLevel] = useState<string>("");

  return (
    <div
      className={`${
        i18n.language === "ar" ? "flex-row" : "flex-row-reverse"
      } flex flex-row mobile:flex-col-reverse tablet:flex-col-reverse justify-between items-center px-10 mobile:px-[10px] max-w-[1139px] w-[calc(100%-40px)] h-[111px] mobile:h-[356px] mobile:w-[calc(100%-98px)] mobile:py-5 tablet:h-[356px] tablet:w-[calc(100%-98px)] tablet:py-5 bg-zinc-50 drop-shadow-[0px_0px_7px_rgba(0,0,0,0.10)] rounded z-20`}
    >
      {/* Mobile Search Button */}
      <Link
        to={appRoutesObj.getResearchResultsPageUrl(
          valueCuntry,
          valueSystem,
          valueLevel
        )}
      >
        <button className="flex justify-center items-center w-40 h-12 bg-mint-500 rounded-xl text-zinc-50 text-xl font-arMedium laptop:hidden largeLaptop:hidden desktop:hidden largeDesktop:hidden">
          {t("searchBar.component.search")}
        </button>
      </Link>
      {/* Country Selection */}
      <SelectSearchBarComponent
        title="searchBar.component.country"
        currrentValue={
          valueCuntry === ""
            ? i18n.language === "ar"
              ? list.selectionListCountry[0]
              : list.selectionListCountryEng[0]
            : valueCuntry
        }
        selectionList={
          i18n.language === "ar"
            ? list.selectionListCountry
            : list.selectionListCountryEng
        }
        onClick={(value: string) => setValueCountry(value)}
      />

      <div className="w-0.5 h-16 bg-neutral-200 mobile:w-full mobile:h-[1px] tablet:w-full tablet:h-[1px]">
        
      </div>
      {/* Academic Systems */}
      <SelectSearchBarComponent
        title="searchBar.component.academicSystem"
        currrentValue={
          valueSystem === ""
            ? i18n.language === "ar"
              ? list.selectionListSystems[0]
              : list.selectionListSystemsEng[0]
            : valueSystem
        }
        selectionList={
          i18n.language === "ar"
            ? list.selectionListSystems
            : list.selectionListSystemsEng
        }
        onClick={(value: string) => setValueSystem(value)}
      />
      <div className="w-0.5 h-16 bg-neutral-200 mobile:w-full mobile:h-[1px] tablet:w-full tablet:h-[1px]"></div>
      {/* Education Level */}
      <SelectSearchBarComponent
        title="searchBar.component.educationLevel"
        currrentValue={
          valueLevel === ""
            ? i18n.language === "ar"
              ? list.selectionListLevels[0]
              : list.selectionListLevelsEng[0]
            : valueLevel
        }
        selectionList={
          i18n.language === "ar"
            ? list.selectionListLevels
            : list.selectionListLevelsEng
        }
        onClick={(value: string) => setValueLevel(value)}
      />
      <Link
        to={appRoutesObj.getResearchResultsPageUrl(
          valueCuntry,
          valueSystem,
          valueLevel
        )}
      >
        <button className="flex justify-center items-center w-40 h-16 bg-mint-500 rounded-xl text-zinc-50 text-xl font-arMedium mobile:hidden tablet:hidden">
          {t("searchBar.component.search")}
        </button>
      </Link>
    </div>
  );
}

export default SearchBarComponent;
